import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { AppService } from './_services/app.service';
import { AuthenticationService } from './_services/authentication.service';
import { ConsultasService } from './_services/consultas.service';
import { UntypedFormBuilder } from '@angular/forms';

import { DialogUploadComponent } from './_components/dialog-upload/dialog-upload.component';
import { ProductReceiveDialogComponent } from './_components/product-receive-dialog/product-receive-dialog.component';
import { ProductPartidaDialogComponent } from './_components/product-partida-dialog/product-partida-dialog.component';


import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false,
    animations: [
      trigger('sidenavWidth', [
        state('collapsed', style({
          width: '64px',
          minWidth: '64px',
          maxWidth: '64px'
        })),
        state('expanded', style({
          width: '280px',
          minWidth: '280px',
          maxWidth: '280px'
        })),
        transition('collapsed <=> expanded', animate('260ms cubic-bezier(0.4, 0, 0.2, 1)'))
      ]),
      trigger('sidenavText', [
        state('collapsed', style({
          opacity: 0,
          maxWidth: '0',
          marginLeft: '0',
          transform: 'translateX(-8px)'
        })),
        state('expanded', style({
          opacity: 1,
          maxWidth: '190px',
          marginLeft: '16px',
          transform: 'translateX(0)'
        })),
        transition('collapsed <=> expanded', animate('200ms 60ms ease'))
      ]),
      trigger('sidenavHeader', [
        state('collapsed', style({
          padding: '0 10px'
        })),
        state('expanded', style({
          padding: '0 10px'
        })),
        transition('collapsed <=> expanded', animate('260ms cubic-bezier(0.4, 0, 0.2, 1)'))
      ]),
      trigger('sidenavTitle', [
        state('collapsed', style({
          maxWidth: '44px',
          opacity: 1,
          transform: 'translateX(0)'
        })),
        state('expanded', style({
          maxWidth: '180px',
          opacity: 1,
          transform: 'translateX(0)'
        })),
        transition('collapsed <=> expanded', animate('240ms cubic-bezier(0.4, 0, 0.2, 1)'))
      ])
    ]
})


export class AppComponent implements OnInit {
  title = 'AZASA';
  sideNavOpened = false;
  sidenavExpanded = false;
  logged = false;
  isOpened = false;
  showingMenuAdd = false;
  user: any;


  fSearch = this.fb.group({
    search: [''],
  });

  isHandset = false;

  get sidenavAnimationState(): 'expanded' | 'collapsed' {
    return this.sidenavExpanded || this.isHandset ? 'expanded' : 'collapsed';
  }

  get isLoginRoute(): boolean {
    return this.router.url.startsWith('/login');
  }

  get isNoPaddingRoute(): boolean {
    return this.router.url.startsWith('/productos');
  }

  constructor(
    private iconRegistry: MatIconRegistry,
    public appSvc: AppService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private authSvc: AuthenticationService,
    private dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private docsSvc: ConsultasService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.iconRegistry.addSvgIcon(
      'pin',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/pin.svg')
    );
    this.iconRegistry.addSvgIcon(
      'trash',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/trash.svg')
    );
    this.iconRegistry.addSvgIcon(
      'trash_opened',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/trash_opened.svg'
      )
    );
  }


  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isHandset = result.matches;
    });
    this.checkIfLogged();
    setTimeout(() => {
      this.appSvc.getComunidades();
    }, 500);
  }

  checkIfLogged() {
    const api_key = localStorage.getItem('api_key');
    if (api_key) {
      this.authSvc.signinCheck().subscribe((res) => {
        if (res.result) {
          this.user = res.data;
          this.logged = true;
          this.isOpened = false;
        } else {
          this.logged = false;
          this.isOpened = false;
        }
      });
    }
  }

  globalSearch() {
    this.appSvc.documentsDocType = 'albaranes';
    this.docsSvc.getByIdent(this.fSearch.value.search, 'albaranes').subscribe((res) => {
      this.router.navigateByUrl('/documentos');
    });
  }

  openFileDialog() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    this.dialog.open(DialogUploadComponent, dialogConfig);
  }

  receiveProduct() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    this.dialog.open(ProductReceiveDialogComponent, dialogConfig);
  }

  createPartida() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    this.dialog.open(ProductPartidaDialogComponent, dialogConfig);
  }

  toggleSideNav(): void {
    this.sideNavOpened = !this.sideNavOpened;
    localStorage.setItem('sideNavOpened', this.sideNavOpened ? 'true' : '');
  }

  closeSideNav(): void {
    this.sideNavOpened = false;
    localStorage.setItem('sideNavOpened', '');
  }

  expandSidenav(): void {
    if (!this.isHandset) {
      this.sidenavExpanded = true;
    }
  }

  collapseSidenav(): void {
    if (!this.isHandset) {
      this.sidenavExpanded = false;
    }
  }

  closeSideNavIfHandset(drawer: { close: () => void }): void {
    if (this.isHandset) {
      drawer.close();
    }
  }

  logout(): void {
    this.authSvc.logout();
    this.checkIfLogged();
    this.router.navigate(['/login']);
  }
}
